<router-outlet></router-outlet>

<div class="mobile-menu-overlay" (click)="hideMobileMenu()"></div>

<molla-mobile-menu></molla-mobile-menu>

<button id="scroll-top" title="Back to Top" [ngClass]="{show: utilsService.isSticky}"
    (click)="utilsService.scrollTop($event)"><i class="icon-arrow-up"></i></button>